{
  "pt": {
    "document": {
      "actions": {
        "clear_selection": "Limpar seleção",
        "delete": "Eliminar",
        "deleteMultipleDocuments": "Eliminar",
        "delete_cancel": "Cancelar",
        "delete_documents": "Eliminar documento | Eliminar documentos",
        "delete_documents_upload": "Remover documento {count} | Remover documentos {count} ",
        "download": "Descarregar",
        "edit": "Editar",
        "edit_category": "Editar categoria",
        "groupByCategory": "Alternar o agrupamento por categoria",
        "hideDetails": "Ocultar detalhes",
        "hide_for_project_partners": "Ocultar para os parceiros do projeto",
        "new": "Documentos",
        "new_customer": "Adicionar documentos",
        "reset_filters": "Redefinir filtros",
        "select_all": "Selecionar todos os {total} documentos",
        "share": "Partilhar",
        "shareCustomer": "Partilhar com o cliente",
        "shareCustomerPartners": "Partilhar com o cliente e os parceiros do projeto",
        "share_documents": "Partilhar documento | Partilhar documentos",
        "share_with": "Partilhar com...",
        "share_with_project_partners": "Partilhar com os parceiros do projeto",
        "showDetails": "Mostrar detalhes",
        "submit": "Enviar",
        "tickBoxesDeletion": "Assinale as caixas de verificação dos ficheiros que pretende eliminar.",
        "unshare": "Anular partilha",
        "unshare_documents": "Anular a partilha de documentos | Anular a partilha de documentos"
      },
      "attachable_types": {
        "building": "Edifício",
        "decisions": "Decisões",
        "installment": "Prestação",
        "issue": "Defeito",
        "lot": "Lote",
        "phase": "Fase",
        "project": "Projeto",
        "tickets": "Conversas",
        "unit": "Unidade"
      },
      "attributes": {
        "category": "Categoria",
        "file_ext": "Tipo de ficheiro",
        "file_size": "Tamanho do ficheiro",
        "name": "Nome",
        "size": "Tamanho",
        "type": "Tipo",
        "uploaded_at": "Carregado em",
        "uploaded_by": "Carregado por"
      },
      "category": {
        "admin": "Administração",
        "aftercare": "Pós-Venda",
        "as_built": "Ficheiro As-built",
        "brochure": "Brochura",
        "conversation": "Conversa",
        "decision": "Decisão",
        "image": "Imagem",
        "invoice": "Fatura",
        "legal": "Jurídico",
        "manual": "Manual",
        "other": "Outro",
        "plan": "Plano",
        "quote": "Orçamento",
        "ticket": "Conversa"
      },
      "labels": {
        "actions": "Ações",
        "allDocuments": "Todos os documentos",
        "allUnits": "Todas as unidades",
        "backToCategories": "Categorias",
        "building": "edifício",
        "categories": "Categorias",
        "category": "Categoria",
        "changeCategory": "Alterar a categoria para:",
        "changeFilterOrStartUploading": "Alterar o filtro ou carregar um novo documento",
        "created": "Criado",
        "customer": "Cliente",
        "decision": "decisão",
        "decisionsAndProposals": "Decisões e propostas",
        "delete_documents": "Tem a certeza de que pretende remover este documento? Esta ação não pode ser anulada. | Tem a certeza de que pretende remover estes documentos? Esta ação não pode ser anulada.",
        "disclaimerDocumentsCustomer": "Procurar ou carregar documentos relacionados com a decisão {decision_name}",
        "documents": "Documentos",
        "documents_all": "Todos os documentos",
        "documents_all_projects": "Documentos de todos os projetos",
        "documents_plan": "Documentos do plano",
        "documents_plan_explainer": "Os documentos adicionados à pasta de documentos {unit_name} com a categoria \"Plano\" são automaticamente adicionados a esta decisão e acessíveis a todos os parceiros. ",
        "editDocument": "Editar documento",
        "editDocumentName": "Editar o nome do documento",
        "editDocumentNameSubtitle": "Introduzir um novo nome para o documento.",
        "fileTooLargeForPreview": "Ficheiro demasiado grande para pré-visualizar. Tente descarregá-lo.",
        "files": "Ficheiros {level_name}",
        "files_count": "Sem ficheiros | 1 ficheiro | {count} ficheiros",
        "filter": "Filtro",
        "folders": "Pastas",
        "goToUnitDocumentsFolder": "Aceder à pasta de documentos de {unit_name}",
        "goToUnitsFolder": "Esta página contém apenas documentos de decisão. Aceda à pasta da unidade para ver os outros documentos.",
        "include_original_documents": "Mostrar os documentos a assinar",
        "includesProposalAndDocuments": "Inclui documentos de proposta e documentos de decisão",
        "info": "Os documentos relacionados com a sua casa estarão brevemente disponíveis aqui.",
        "lockedDocumentApprovedProposal": "Este documento pertence a uma proposta aprovada e não pode ser eliminado",
        "lockedDocumentDelete": "Este documento não pode ser eliminado",
        "lockedDocumentOtherLevel": "Este documento pertence a {level} e só pode ser eliminado a partir dos documentos de {level}",
        "lockedDocumentShareLevel": "Este documento pertence a {level} e não pode ser partilhado com os parceiros do projeto",
        "locked_parent_level": "Este documento é gerido num nível superior e só pode ser editado ou eliminado nesse nível",
        "locked_template": "Este documento foi criado a partir de um modelo e não pode ser editado ou eliminado",
        "lot": "lote",
        "more_info": "Mais informações",
        "name_asc": "Nome A->Z",
        "name_desc": "Nome Z->A",
        "name_lower_asc": "Nome A->Z",
        "name_lower_desc": "Nome Z->A",
        "new": "Novo",
        "next": "Seguinte",
        "noCustomer": "Nenhum cliente atribuído ainda",
        "noPreviewPossible": "Não é possível efetuar uma pré-visualização para este tipo de documento. Tente descarregá-lo primeiro.",
        "noResults": "Sem resultados",
        "no_plan_documents": "Não foram adicionados documentos de planeamento à pasta da unidade",
        "onlyUnitDocumentsSharedWithProjectPartners": "Apenas os documentos da Unidade podem ser partilhados com os parceiros do projeto",
        "original_documents": "Documentos originais",
        "original_documents_info": "Mostrar as versões originais não assinadas dos documentos que estão assinados ou precisam de ser assinados.",
        "owner": "Proprietário",
        "page": "Página",
        "phase": "fase",
        "previous": "Anterior",
        "project": "projeto",
        "project_partners": "Parceiros do projeto",
        "proposal": "proposta",
        "searchName": "Pesquisar por nome",
        "search_document": "Pesquisar documento",
        "selected": "{count} documento selecionado | {count} documentos selecionados",
        "selected_count": "{selected} documento selecionado | {selected} documentos selecionados",
        "shareWith": "Partilhar com",
        "sharedWithClient": "Partilhado com {client_name}",
        "sharedWithProjectPartners": "Partilhado com os parceiros do projeto",
        "shared_with": "Partilhado com",
        "shared_with_partners": "Partilhado com parceiros",
        "sharingSettingsDecision": "No âmbito desta decisão",
        "sharingSettingsProject": "Neste projeto",
        "showDocumentsFor": "Mostrar documentos para",
        "showLevel": "Este é um documento {level} ",
        "signature": "Assinatura",
        "signed": "Assinado",
        "signedBy": "Assinado por",
        "source": "Fonte",
        "subtitleSharingDocuments": "O documento selecionado estará disponível para os parceiros do projeto | Os documentos seleccionados estarão disponíveis para os parceiros do projeto",
        "subtitleUnsharingDocuments": "O documento selecionado não estará disponível para os parceiros de projeto | Os documentos seleccionados não estarão disponíveis para os parceiros de projeto",
        "ticket": "conversa",
        "total_selected": "Todos os {total} documentos selecionados",
        "unit": "unidade",
        "unitFolder": "Ir para os documentos da unidade",
        "updated_at_asc": "Mais antigo primeiro",
        "updated_at_desc": "Mais recente primeiro",
        "upload_failed": "1 ou mais ficheiros não foram carregados. Remova-os ou tente carregar novamente.",
        "uploadedBy": "Carregado por",
        "visibleFor": "Partilhado com",
        "warningNotShared": "Ups! Ninguém foi selecionado. Tem a certeza? Clique novamente para confirmar."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Receberá uma notificação por e-mail quando um novo documento estiver disponível. Veja e descarregue-os aqui.",
            "title": "Aqui encontra todos os seus documentos"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Os carregamentos de documentos serão automaticamente notificados por e-mail a todos os clientes relacionados.",
            "title": "Não há documentos para {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navegar pela estrutura do projeto para ver os documentos de uma unidade",
            "title": "Ir a uma unidade para ver documentos"
          },
          "new": {
            "subtitle": "Os carregamentos de documentos serão automaticamente notificados por e-mail a todos os clientes relacionados.",
            "title": "Não há documentos para esta decisão"
          },
          "none": {
            "subtitle": "Aqui encontra documentos para {unit}",
            "title": "Ainda não há documentos"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Documento eliminado com êxito | Documentos eliminados com êxito",
        "bulk_upload": "Documento carregado com sucesso | Documentos carregados com sucesso",
        "update": "{count} documento atualizado com êxito | {count} documentos atualizados com êxito",
        "upload_success": "{count} documento carregado com sucesso | {count} documentos carregados com sucesso"
      },
      "upload": {
        "activeUpload": "A carregar {count} ficheiro | A carregar {count} ficheiros",
        "clear": "Limpar",
        "complete": "Carregamento concluído",
        "navigationWarning": {
          "continue": "Sair mesmo assim",
          "header": "Carregamento em curso",
          "message": "Existem ficheiros a ser carregados. Sair desta página cancelará o carregamento e nenhum documento será criado."
        },
        "uploadFailed": "O carregamento falhou"
      },
      "validation": {
        "need_category": "Categoria obrigatória",
        "need_category_all": "Todos os documentos devem ter uma categoria",
        "selectDocument": "Selecionar pelo menos 1 documento"
      }
    }
  }
}
